export function isReactSnap() {
  return (
    typeof navigator !== "undefined" &&
    navigator.userAgent.includes("ReactSnap")
  );
}
